<template>
	<layout-admin-basic class="admin-static-content static-content-terms">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<span slot="header">{{ header }}</span>
		<spinner v-if="collection.loading"/>
		<error-box v-else-if="collection.error" :error="collection.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<div class="tab">
				<button class="tablinks" v-for="item in collection.data" :key="item.id" @click.prevent="openTab(item.id)">
					<shape :src="shapeSrc(item.lang)" class="flag" :class="{ selected: isSelected(item.id) }"/>
					<span>{{ item.lang }}</span>
				</button>
			</div>
			<div class="tabcontent" v-for="(item, index) in collection.data" :key="item.id" v-show="isSelected(item.id)">
				<wysiwyg v-model="collection.data[index].content"/>
			</div>
			<br>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</layout-admin-basic>
</template>

<script>
import LayoutAdminBasic from '../LayoutAdminBasic'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
import ApiCollection from '@/classes/api/ApiCollection'
import FormObject from '@/classes/api/FormObject'
export default {
	components: {
		LayoutAdminBasic,
		AdminBreadcrumbs
	},
	props: [
		'name'
	],
	data () {
		return {
			collection: new ApiCollection(),
			form: new FormObject(),
			selected: null,
			flags: new Map([
				['en-gb', '/static/svg/flags/uk.svg'],
				['fr',    '/static/svg/flags/fr.svg'],
				['pt',    '/static/svg/flags/pt.svg']
			]),
			headers: new Map([
				['use-policy', 'Use Policy'],
				['privacy-policy', 'Privacy Policy'],
				['terms', 'Terms Of Use']
			])
		}
	},
	computed: {
		header () {
			return this.headers.get(this.name)
		},
		breadcrumbs () {
			return [
				{
					title: this.header
				}
			]
		}
	},
	watch: {
		'$route' () {
			this.getCollection()
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editItem()
				})
		},
		getCollection () {
			this.collection.loading = true
			this.$api.statics.getStaticContent(this, this.name)
				.then(response => {
					this.$log.info('admin', 'statics.getStaticContent OK', response)()
					this.collection.data = response.body.length ? response.body : []
					if (this.collection.data.length) {
						this.collection.data.sort((a, b) => {
							if (a.lang < b.lang) return -1
							if (a.lang > b.lang) return 1
							return 0
						})
						this.selected = this.collection.data[0].id
					}
				})
				.catch(error => {
					this.$log.error('admin', 'statics.getStaticContent ERROR', error)()
					this.collection.error = error
				})
				.finally(() => {
					this.collection.loading = false
				})
		},
		editItem () {
			this.form.loading = true
			this.$api.statics.editStaticContent(this, this.name, this.collection.data)
				.then(response => {
					this.$log.info('admin', 'statics.editStaticContent OK', response)()
				})
				.catch(error => {
					this.$log.error('admin', 'statics.editStaticContent ERROR', error)()
					this.form.error = error
				})
				.finally(() => {
					this.form.loading = false
					this.getCollection()
				})
		},
		openTab (value) {
			this.selected = value
		},
		shapeSrc (value) {
			return this.flags.get(value)
		},
		isSelected (value) {
			return this.selected == value
		}
	},
	mounted () {
		this.getCollection()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/statics/AdminStaticContentTerms.vue